import axiosInstance from "../config/axios";

export interface ReimbursementAccessRecord {
  user_id: string;
  read_access: boolean;
  write_access: boolean;
  initiator: boolean;
  reviewer: boolean;
  reviewer_2: boolean;
  recommender: boolean;
  sanction_authority_1: boolean;
  reporting_manager: boolean;
  is_reporting_manager: boolean;
}

interface ReimbursementAccessResponse {
  data: ReimbursementAccessRecord[];
}

async function getUserAccess(): Promise<ReimbursementAccessRecord | null> {
  const response = await axiosInstance.get<ReimbursementAccessResponse>("/hrms/reimbursement/access");
  return response.data?.data?.[0] || null;
}

export const reimbursementAccessService = {
  getUserAccess,
};

export default reimbursementAccessService;
